import React from "react";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">USERNAME</div>
      <div className="menuExchange">P/L</div>
      <div className="menuExchange">M2M</div>
      <div className="menuExchange">COMMISSION</div>
      <div className="menuExchange">BROKER-C</div>
      <div className="menuExchange">TOTAL</div>
      <div className="menuExchange">BROKER-S</div>
      <div className="menuExchange">BROKER NET</div>
      <div className="menuExchange">MASTER NET</div>
    </div>
  );
}
